import { Showable } from "../../../mixins/Showable";
import { ContentsScrollPane } from "../ContentsScrollPane";
import { RulesCategoryLocData, RulesCategoryThemeData, RulesLocData, RulesThemeData } from "../../../types/types";
import { RulesCategoryContent } from "./RulesCategoryContent";
import { AppObjectPool } from "../../pooling/AppObjectPool";


export interface RulesContentsScroll extends Showable { }

export class RulesContentsScroll
    extends ContentsScrollPane {
    private locData: RulesLocData;
    private themeData: RulesThemeData;
    private RULES_CATEGORY_CONTENT_POOL_KEY: string = "RulesCategoryContent";

    public override Init(
        cullItems: boolean = true,
        referenceWidth: number = undefined,
    ): void {
        // > referenceWidth
        // > scrollAxis
        // > excessScrollAmount
        // > contentsScrollData
        // > contents
        super.Init(cullItems, referenceWidth);

        this.excessScrollAmount.Set(0, 0, 0, 50);
    }

    /**
     * Set different category items (types, counts, loc/texts)
     * 
     * NOTE: Categories are created at this point, with default items within them (from Init nodes)
     * NOTE: number of cats STAYS. Number/type of items within each cat CHANGES.
     */
    public SetData(
        locData: RulesLocData = undefined,
        themeData: RulesThemeData = undefined,
    ): void {
        // console.log("SetData");

        if (locData) {
            this.locData = locData;
        }
        if (themeData) {
            this.themeData = themeData;
        }

        // update view
        // console.log(this.contents.length,"->",this.locData.categories.length);
        // first, pool all categories
        while (this.contents.length) {
            const removedCat: RulesCategoryContent = this.contents.pop() as RulesCategoryContent;
            removedCat.poolItems();
            this.remove(removedCat);
            AppObjectPool.DropObject(removedCat, this.RULES_CATEGORY_CONTENT_POOL_KEY);
        }

        // next grab as many as you need from pool
        for (let i=0; i<this.locData.categories.length; i++) {
            const catLocData: RulesCategoryLocData = this.locData.categories[i];
            const catThemeData: RulesCategoryThemeData = this.themeData.categories[i];

            const catContent: RulesCategoryContent = this.GetFromPoolOrNew();
            catContent.SetData(catLocData, catThemeData);
            this.contents.push(catContent);
            this.content.add(catContent);
        }
    }

    private GetFromPoolOrNew(): RulesCategoryContent {
        let item: RulesCategoryContent = AppObjectPool.PickObject(this.RULES_CATEGORY_CONTENT_POOL_KEY);
        if (item == null) {
            item = new RulesCategoryContent(this.scene);
            item.Init();
            item.Build();
        }
        return item;
    }

    /**
     * Update scroll data for scrollPane (followed by view update: capitalizedTitle..)
     * 
     * NOTE: Called from parent through this base @see ScrollPane::UpdateFromLocalizationChange
     * NOTE: Called via parent::SetData
     * NOTE: this.contentsScrollData updated by now @see SetData
     */
    public override UpdateFromLocalizationChange(): void {
        // console.log("UpdateFromLocalizationChange");
        this.contentsScrollData = [];
        this.locData.categories.forEach((catLocData: RulesCategoryLocData) => {
            const catTitle: string = catLocData.title.itemLabel;
            this.contentsScrollData.push({
                title: catTitle,
                capitalizedTitle: catTitle.toUpperCase(),
            });
        });
    }
}